/* eslint-disable no-restricted-syntax */
import CopyrightInteractive from 'components/atoms/copyright/copyright';
import FigureVideo from './FigureVideo';

export default function initFigure($target) {
  const scope = $target || document;
  scope.querySelectorAll('.js-figure').forEach(($figure) => {
    // External Videos with overlay
    const figureVideo = new FigureVideo($figure, {});

    // Interactive Copyright
    const $figureCopyrightWrapper = $figure.querySelector('.figure__copyright');
    const $figureCopyright =
      $figureCopyrightWrapper?.querySelector('.copyright');
    if ($figureCopyright) {
      const interactiveCopyright = new CopyrightInteractive($figureCopyright);
    }

    // Remove copyright and caption from screenreader when alt tag is empty
    // With this approach, the copyright remains clickable for sighted users

    const $picture = $figure.querySelector('.picture__image');
    const alt = $picture?.getAttribute('alt');
    const isDecorative = alt === '' || alt === null || alt === ' ';

    [
      $figure,
      $figureCopyrightWrapper,
      $figure.querySelector('.figure__caption'),
      $figureCopyright?.querySelector('.copyright__trigger'),
    ].forEach(($el) => {
      if ($el && isDecorative) {
        $el.setAttribute('aria-hidden', 'true');
      } else if ($el) {
        $el.removeAttribute('aria-hidden');
      }
    });
  });
}

initFigure();

/**
 * Throw this custom event on the document to re-initialize the figure js, e.g. after loading content via AJAX
 *
 * const targetScope = document.querySelector('#your-target-scope') || document;
 * const figureInit = new CustomEvent('figureInit', {
 *  bubbles: true,
 *  detail: {
 *     scope: targetScope,
 *   },
 * });
 * document.dispatchEvent(figureInit);
 */
document.addEventListener('figureInit', (event) => {
  const { scope } = event.detail;
  initFigure(scope);
});
